export default function Cancel() {
  return (
    <div className="min-h-screen flex items-center justify-center text-center">
      <h1 className="text-3xl font-bold text-red-600">
        ❌ Payment Canceled
      </h1>
      <p className="mt-4 text-gray-600">Your payment was canceled. You can return to the shop anytime.</p>
    </div>
  )
}